/**
 * Custom Sticky ATC (mobile)
 * --------------------------
 * Drives <custom-sticky-atc> (see snippets/custom-sticky-atc.liquid):
 *   - Shows a fixed bottom Add-to-cart bar (mobile only, via CSS) while the real
 *     product-form button is scrolled OUT of view; hides it once the real button is
 *     in view, so the real button "parks" in its place.
 *   - Opens a quick-add variant sheet when configured; otherwise forwards clicks
 *     to the real button, so the theme's <product-form> handles the AJAX add.
 *   - Mirrors the real button's disabled state and label in direct-submit mode.
 *
 * Non-invasive: only reads the real button and toggles its own class.
 */
(function () {
  'use strict';

  if (window.customElements && customElements.get('custom-sticky-atc')) return;

  class CustomStickyAtc extends HTMLElement {
    connectedCallback() {
      if (this._init) return;

      this.realBtn = document.getElementById(this.getAttribute('data-real-button'));
      this.proxyBtn = this.querySelector('[data-sticky-atc-trigger]');
      this.label = this.querySelector('[data-sticky-atc-label]');
      if (!this.realBtn || !this.proxyBtn) return;

      this._init = true;
      this._usesQuickAddSheet = this.proxyBtn.hasAttribute('data-fc-quick-add-trigger');
      this._initialProxyDisabled = this.proxyBtn.disabled;

      // Forward clicks to the real form button unless this button is configured
      // as a quick-add sheet trigger handled by product-card-variants-global.
      this.proxyBtn.addEventListener('click', () => {
        if (this._usesQuickAddSheet) return;
        if (!this.realBtn.disabled) this.realBtn.click();
      });

      // Mirror the real button's disabled state + label (sold out, unavailable…).
      this._sync();
      this._mo = new MutationObserver(() => this._sync());
      this._mo.observe(this.realBtn, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
      });

      // Show the bar only while the real button is out of view.
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(
          (entries) => {
            this.classList.toggle('is-visible', !entries[0].isIntersecting);
          },
          { threshold: 0 }
        );
        this._io.observe(this.realBtn);
      } else {
        this.classList.add('is-visible');
      }
    }

    disconnectedCallback() {
      if (this._mo) this._mo.disconnect();
      if (this._io) this._io.disconnect();
    }

    _sync() {
      if (this._usesQuickAddSheet) {
        this.proxyBtn.disabled = this._initialProxyDisabled;
        return;
      }

      this.proxyBtn.disabled = !!this.realBtn.disabled;
      var realText = this.realBtn.querySelector('[data-button-text]');
      if (realText && this.label) {
        this.label.textContent = realText.textContent.trim();
      }
    }
  }

  customElements.define('custom-sticky-atc', CustomStickyAtc);
})();
